import { useAuthStore } from "@/stores/authStore";

export interface FiInfo {
  fiNumber: string;
  fiName: string;
}

/**
 * Get the FI name from the cached FI list by fiNumber
 * @param fiNumber - The FI number to look up
 * @returns The FI name if found, null otherwise
 */
export function getFiName(fiNumber: string): string | null {
  const authStore = useAuthStore();
  const fi = authStore.allFis.find(f => f.fiNumber === fiNumber);
  return fi ? fi.fiName : null;
}

/**
 * Get the FI info object by fiNumber
 * @param fiNumber - The FI number to look up
 * @returns The FI object if found, null otherwise
 */
export function getFiInfo(fiNumber: string): FiInfo | null {
  const authStore = useAuthStore();
  return authStore.allFis.find(f => f.fiNumber === fiNumber) || null;
}

/**
 * Search for FIs by matching against both fiNumber and fiName
 * @param searchTerm - The search string to match against
 * @returns Array of matching FI objects
 */
export function searchFis(searchTerm: string): FiInfo[] {
  const authStore = useAuthStore();

  if (!searchTerm || searchTerm.trim() === '') {
    return authStore.allFis;
  }

  const lowerSearch = searchTerm.toLowerCase();

  return authStore.allFis.filter(fi =>
    fi.fiNumber.toLowerCase().includes(lowerSearch) ||
    fi.fiName.toLowerCase().includes(lowerSearch)
  );
}
